// sidebar & working area
import Sidebar from "./Sidebar";
import WorkingArea from "./WorkingArea";

// styled
import styled from "styled-components";

const SpecificationsPage = () => (
    <Layout>
        <Sidebar />
        <WorkingArea />
    </Layout>
);

const Layout = styled.div`
    display: flex;
    height: calc(100vh - 127px);
    width: 100%;
`;

export default SpecificationsPage;
